<template>
  <div
    :class="{ clickable: !state.isEdit }"
    class="document-before-print-au-tfn-edit-row"
    @click="edit"
  >
    <div v-if="state.isEdit">
      <input
        ref="input"
        :value="localValue"
        @input="({ target }) => $emit('update:value', target.value)"
        @blur="state.isEdit = false"
        @focusout="state.isEdit = false"
      />
    </div>
    <div v-if="!state.isEdit">{{ localValue }}</div>
    <i v-if="!state.isEdit" class="fas fa-pen-square"></i>
  </div>
</template>

<script>
import { reactive, computed, nextTick, ref } from 'vue';

export default {
  name: 'document-before-print-au-tfn-edit-row',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const input = ref(null);
    const state = reactive({
      isEdit: false,
    });
    const localValue = computed(() => {
      return props.value;
    });

    function edit() {
      if (state.isEdit) {
        return true;
      }

      emit('edit');
      state.isEdit = true;
      nextTick(() => input.value.focus());
    }

    return {
      input,
      localValue,
      state,
      edit,
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/core/style-vars.scss';

.document-before-print-au-tfn-edit-row {
  position: relative;
  width: 100%;
  height: 100%;
}

.document-before-print-au-tfn-edit-row i {
  position: absolute;
  right: 0;
  top: 3px;
}

input {
  border: 0;
  height: 15px;
  border-bottom: 1px solid $blue;
  width: 100%;
}

.clickable {
  cursor: pointer;
}

@media print {
  i {
    display: none;
  }

  input {
    font-family: Arial, sans-serif;
    border: 0;
    font-size: 10px;
  }
}
</style>
